import React from "react";
import {Container, Row} from "react-bootstrap";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {mygaSession} from "../../../scripts/myga-session";
import {toCurrency} from "../../../scripts/myga-utils";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {productForDTO} from "../../../scripts/product-manager";
import {MM_PAYMENT, MM_PAYMENT_TYPE, MM_PRODUCT, MM_PRODUCT_DTO, MM_PRODUCT_VISUALS} from "../../../scripts/myga-model";

class MailCheckInfo extends React.Component {
    
    onBackPressed = async () => {
    };
    
    onNextPressed = async () => {
    };
    
    getPayments = () => {
        let eftPayments = [];
        mygaSession.getCurrentAppProductDTOs().forEach((dto)=>{
            const product = productForDTO(dto);
            dto[MM_PRODUCT_DTO.payments].forEach((payment)=>{
                if (payment[MM_PAYMENT.paymentType]===MM_PAYMENT_TYPE.check) {
                    eftPayments.push({
                        [MM_PRODUCT.productName]: product[MM_PRODUCT.productName],
                        [MM_PRODUCT_VISUALS.tradeMark]: product[MM_PRODUCT.visuals][MM_PRODUCT_VISUALS.tradeMark],
                        [MM_PRODUCT_VISUALS.surrenderPeriod]: product[MM_PRODUCT.visuals][MM_PRODUCT_VISUALS.surrenderPeriod],
                        [MM_PAYMENT.amount]: payment[MM_PAYMENT.amount]
                    })
                }
            });
        });
        return eftPayments;
    }
    
    render() {

    return (

      <AppContentWrapper
        onBackPressed={this.onBackPressed}
        onNextPressed={this.onNextPressed}
        updatePage={this.props.updatePage}>


                    {/*
                        Mailing Instructions
                    */}
                    <div id={'mailCheckInfoContainer'}  className="container page-section disclaimer p-1">
                        <Container className={"p-2 font-page-large"}>
                            {
                                this.getPayments().map((payment,index)=>{
                                    return (
                                        <Row key={index}>
                                            <div className="col-11 font-weight-bold">
                                                {payment[MM_PRODUCT.productName]}
                                                <sup>{payment[MM_PRODUCT_VISUALS.tradeMark]}</sup>
                                                {`  ${payment[MM_PRODUCT_VISUALS.surrenderPeriod]}, Check: ${toCurrency(parseFloat(payment[MM_PAYMENT.amount]))}`}
                                            </div>
                                        </Row>
                                    );
                                })
                            }
                        </Container>
    
                        <Container className="page-section">
                            <Row className={"p-1"}>
                                <div className="col-11 font-weight-bold">
                                    Instructions:
                                </div>
                            </Row>
                            <Row className={"p-1"}>
                                <div className="col-11">
                                    {MYGAStrings.MailCheckInfo_ConfirmationInfo}
                                </div>
                            </Row>
                            <Row className={"p-1"}>
                                <div className="col-11">
                                    <b>Send via regular mail to:</b><br/>
                                    Nassau<br/>
                                    P.O. Box 22012<br/>
                                    Albany, NY 12201-2012<br/>
                                </div>
                            </Row>
                            <Row className={"p-1"}>
                                <div className="col-11">
                                    <b>Send via express mail to:</b><br/>
                                    Nassau<br/>
                                    15 Tech Valley Drive<br/>
                                    Suite 201<br/>
                                    East Greenbush, NY 12061-4142<br/>
                                </div>
                            </Row>
                        </Container>
                    </div>

      </AppContentWrapper>


    );

  }
}

export default MailCheckInfo;